// components/Surveys/SingleChoiceInput.js
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  font: 16px/1.4 'Inter',sans-serif;
  color: #161616;

  &:last-child {
    border-bottom: none;
  }
`

const Radio = styled.input.attrs({ type: 'radio' })`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  position: relative;
  cursor: pointer;

  &:checked::before {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    background: #28aae1;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export default function SingleChoiceInput({
  options,
  otherEnabled = false,
  value = null,      // guardamos aqui o label selecionado
  onChange
}) {
  const isOther =
    otherEnabled &&
    value != null &&
    !options.some(o => o.label === value)

  return (
    <Container>
      {options.map(opt => (
        <OptionLabel key={opt.id}>
          <Radio
            name="single-choice"
            checked={value === opt.label}
            onChange={() => onChange(opt.label)}
          />
          {opt.label}
        </OptionLabel>
      ))}

      {otherEnabled && (
        <OptionLabel>
          <Radio
            name="single-choice"
            checked={isOther}
            onChange={() => onChange('')}
          />
          Outro
        </OptionLabel>
      )}
    </Container>
  )
}
